export enum eSingleFields {
  loan_amount = 'loan_amount',
  estimated_property_value = 'estimated_property_value',
  purchase_price = 'purchase_price',
  loan_number = 'loan_number',
}

export const DisplaySingleFields = {
  [eSingleFields.loan_amount]: 'Loan Amount',
  [eSingleFields.estimated_property_value]: 'Estimated Property Value',
  [eSingleFields.purchase_price]: 'Purchase Price',
  [eSingleFields.loan_number]: 'Loan Number',
};
